import { createContext } from 'react';
import { createRepository } from '@water-web/repository';

export const RepositoryContext = createContext<ReturnType<typeof createRepository>>(null);
